import Dexie from 'dexie';

const db = new Dexie('loopy-doopy');
db.version(1).stores({
    videos: '++id, videoId, name',
    loops: '++id, name, start, end, videoId'
});

export default db;